import "./ArrowUp.scss";

const ArrowUp = () => {
  return (
    <div className="circle-arrow-up">
      <div className="arrow-up"></div>
    </div>
  );
};

export default ArrowUp;
